var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useSelectedDispute from '../../../../hooks/useSelectedDispute';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { t } from '../../../../strings/i18n/i18n';
import styled from 'styled-components';
import { Stack } from 'syf-component-library/ui/spacing';
import { generateUUID, triggerAnalyticsEvent } from 'syf-js-utilities';
import { Analytics } from '../../../../helpers/analyticsMiddleware';
import DisputeHistoryItem from './DisputeHistoryItem';
import getDisputeInfoPageName from '../helpers';
var DisputeHistoryContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var HistoryDetailsText = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
var HistoryItemListContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var DisputeHistory = function () {
    var assetsURL = useSelector(function (state) { return state; }).mfeConfig.assetsURL;
    var _a = useSelectedDispute(), selectedDispute = _a.selectedDispute, selectedTransaction = _a.selectedTransaction, transactionDisputeHistory = _a.transactionDisputeHistory;
    var disputeReason = selectedTransaction.disputeReason, transactionStatus = selectedTransaction.statusCode;
    var caseId = selectedDispute.caseId;
    useEffect(function () {
        var pageAttributes = getDisputeInfoPageName(transactionStatus);
        triggerAnalyticsEvent(__assign({ pageKind: Analytics.Dispute, pageFunction: Analytics.History, message: disputeReason }, pageAttributes));
    }, [disputeReason, transactionStatus]);
    return (_jsxs(DisputeHistoryContainer, { children: [_jsx(Stack, { size: "large" }), _jsx(HistoryDetailsText, __assign({ "data-cy": "dispute-history-description" }, { children: t('disputeDetails.historyDetails', { disputeId: caseId }) })), _jsx(HistoryItemListContainer, { children: transactionDisputeHistory.map(function (_a) {
                    var caseStatus = _a.caseStatus, date = _a.date, documentsCount = _a.documentsCount, notes = _a.notes, notesAddedBy = _a.notesAddedBy;
                    return (_jsx(DisputeHistoryItem, { assetsURL: assetsURL, caseStatus: caseStatus, date: date, documentsCount: documentsCount, notes: notes, notesAddedBy: notesAddedBy }, generateUUID()));
                }) })] }));
};
export default DisputeHistory;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map